import styles from './Criteria.module.scss'
import { motion } from "framer-motion"
import {phone} from '../../utils/data'

const titleAnimation = {
    hidden: {
        y: 100,
        opacity: 0,
    },

    visible: {
        y: 0,
        opacity: 1,
        transition: { duration: .3 }
    }
}

const cardAnimation = {
    hidden: {
        y: 100,
        opacity: 0,
    },
    visible: {
        y: 0,
        opacity: 1,
        transition: { duration: .4}
    } 
}


const Criteria = ({isRus}) => {

    return (
        <motion.section 
        className={styles.main}
        id='preimushchestva' 
        initial='hidden'
        whileInView='visible'
        viewport={{amount: 0.05, once: true}}
        >       
        <div className={styles.container}>
            <motion.h2 className={styles.title} variants={titleAnimation}>{ isRus  ? 'Как будет проходить наша совместная работа' : 'How will our joint work go?'}</motion.h2>
            { isRus  ? <motion.p className={styles.subtitle} variants={titleAnimation}>В течение 4-х рабочих сессий с участием руководителей ключевых направлений (продажи, производство, финансы, маркетинг, сервис, HR) мы вместе:</motion.p> : <motion.p className={styles.subtitle} variants={titleAnimation}><span>4 full days</span> working session, together with company’s sales & marketing, finance, HR managers to work on:</motion.p>}
            
        <motion.ul className={styles.list}>
                    <motion.li 
                        className={styles.item}
                        variants={cardAnimation}
                        initial='hidden'
                        whileInView='visible'
                        viewport={{amount: 0.05, once: true}}
                        >
                            <div className={styles.item_box} >
                                <p className={styles.item_number}>01</p>
                                <p className={styles.item_text}>{ isRus  ? 'Рассмотрим лучшие бизнес – практики и стандарты, используемые в Американских корпорациях' : 'How to implement the best business practices and processes used by American corporations as ACE standards'}
                                </p>
                            </div>
                    </motion.li>
                    <motion.li 
                        className={styles.item}
                        variants={cardAnimation}
                        initial='hidden'
                        whileInView='visible'
                        viewport={{amount: 0.05, once: true}}
                        >
                            <div className={styles.item_box} >
                                <p className={styles.item_number}>02</p>
                                <p className={styles.item_text}>{ isRus  ? 'Разработаем стратегию достижения лидирующих позиций на рынке' : 'To develop a strategy how to achieve leadership positions'}
                                </p>
                            </div>
                    </motion.li>
                    <motion.li 
                        className={styles.item}
                        variants={cardAnimation}
                        initial='hidden'
                        whileInView='visible'
                        viewport={{amount: 0.05, once: true}}
                        >
                            <div className={styles.item_box} >
                                <p className={styles.item_number}>03</p>
                                <p className={styles.item_text}>{ isRus  ? 'Проведем конкурентный и финансовый анализ (опционально)' : 'To consider competition, including marketing and financial analysis (optional)'}</p>
                            </div>
                    </motion.li>
                    <motion.li 
                        className={styles.item}
                        variants={cardAnimation}
                        initial='hidden'
                        whileInView='visible'
                        viewport={{amount: 0.05, once: true}}
                        >
                            <div className={styles.item_box} >
                                <p className={styles.item_number}>04</p>
                                <p className={styles.item_text}>{ isRus  ? 'Определим мероприятия, необходимые для устранения препятствий в достижении стратегических задач ' : 'Clear actions to achieve strategic goals'}</p>
                            </div>
                    </motion.li>
                    <motion.li 
                        className={styles.item}
                        variants={cardAnimation}
                        initial='hidden'
                        whileInView='visible'
                        viewport={{amount: 0.05, once: true}}
                        >
                            <div className={styles.item_box} >
                                <p className={styles.item_number}>05</p>
                                <p className={styles.item_text}>{ isRus  ? 'Результатом совместной работы будет являться разработанный для утверждения руководством компании / советом директоров календарный план по реализации мероприятий для достижения стратегических целей.' : 'The result of our work will be detailed ACE action plan to ensure long term leadership'}</p>
                            </div>
                    </motion.li>
                </motion.ul>
                <motion.p className={styles.subtitle} variants={titleAnimation}>{ isRus  ? ' Надеюсь, что мой 20-летний успешный опыт работы в развитии бизнеса крупной Американской компании, окажется полезным для технологичных компаний в увеличении продаж и завоевании и лидерских рыночных позиций.' : 'I strongly believe that my 20 Years successful business background and achievements @ Carrier Corp, will be useful for tech companies helping them to grow sales and strengthening leadership positions in the segment.'}</motion.p>
                <a className={styles.button} target='_blank' rel='noopener noreferrer' href={'https://wa.me/' + phone} aria-label='связаться вацап'>
                                <span>{ isRus  ? 'Задать свой вопрос в WhatsАpp' : 'Ask your question in WhatsApp'}</span>
                                <svg  xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.92327 0.277344C4.59796 0.277344 0.2771 4.5982 0.2771 9.92351C0.2771 12.0559 0.967314 14.0199 2.13451 15.6192L0.905588 19.2554L4.73824 18.0602C6.23651 19.0141 8.01536 19.5697 9.92327 19.5697C15.2486 19.5697 19.5694 15.2488 19.5694 9.92351C19.5694 4.5982 15.2486 0.277344 9.92327 0.277344ZM14.3395 15.0973C12.5887 15.7988 10.5013 15.1198 8.21737 13.3858C5.93349 11.6519 4.42961 9.21085 4.3286 7.39834C4.2276 5.58582 5.70342 4.67115 6.50587 4.67676C7.30831 4.68237 8.18932 7.24683 8.20054 7.63963C8.21176 8.03805 7.21853 8.7451 7.17925 9.08179C7.13997 9.41848 8.53162 11.0795 9.12083 11.5284C9.70442 11.9717 10.9109 12.8247 11.5338 12.7461C12.151 12.6619 12.5607 11.4218 12.9535 11.3432C13.3463 11.2647 15.4899 12.3308 15.7031 12.6058C15.9164 12.8864 15.8939 14.4801 14.3395 15.0973Z"></path>
                                </svg>
                            </a>
        </div>   
    </motion.section>
    )
}

export default Criteria